module.exports = __webpack_public_path__ + "static/media/AI_Separator.ede6cf72.svg";